import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Button, Col, ListGroup, ListGroupItem} from "reactstrap";
import cx from 'classnames';
import Loader from "react-loaders";
import qs from "qs";
import {Trans, useTranslation} from "react-i18next";

import {loadGroups} from "../../../thunks/Connect";
import {clearErrors} from "../../../actions/Connect";


const VKGroups = (
    {
        activeShop,
        isSendingRequest,
        groups,
        loadGroups,
        clearErrors,
    }
) => {
    const {t, i18n} = useTranslation();

    // ComponentDidMount
    useEffect(() => {
        clearErrors();
        loadGroups(process.env.REACT_APP_SERVICEVK_URL);
    }, []);

    const listGroupItems = (groups || []).map(
        (group, idx) => {
            // Attention! This redirect URL is used in servicevk python code! DO NOT CHANGE!
            const nextTo = qs.stringify({next_to: `${window.location.protocol}//${window.location.hostname}/panel/#/${activeShop.id}/dashboard`});
            const redirectUri = qs.stringify({redirect_uri: `${window.location.protocol}//${window.location.hostname}/service/servicevk/oauth/login_group?shop_id=${activeShop.id}&vk_group_id=${group.id}&${nextTo}`});
            const oauthUrl = `https://oauth.vk.com/authorize?client_id=${process.env.REACT_APP_VK_APP_ID}&scope=messages,photos,docs,stories,manage&response_type=code&v=5.103&group_ids=${group.id}&${redirectUri}`;

            return <ListGroupItem key={idx} className={cx({'border-0': idx === 0})}>
                <div className="widget-content p-0">
                    <div className="widget-content-wrapper">
                        <div className="widget-content-left mr-3">
                            <img width={42} className="rounded-circle" src={group.photo_100}/>
                        </div>
                        <div className="widget-content-left">
                            <div className="widget-heading">
                                {group.name}
                            </div>
                            <div className="widget-subheading">
                                {t('connect_bot.vk.groups.subscribers', 'Subscribers')}: {group.members_count}
                            </div>
                        </div>
                        <div className="widget-content-right">
                            <a href={oauthUrl}>
                                <Button color="primary">{t('connect_bot.common.submit', 'Connect')}</Button>
                            </a>
                            {/*<Button outline color="success" disabled>Connected</Button>*/}
                        </div>
                    </div>
                </div>
            </ListGroupItem>;
        }
    );

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        {
                            (!isSendingRequest && groups !== undefined) &&
                            <div className="h5 modal-title text-center">
                                <h4 className="mt-4 mb-4">
                                    <div>
                                        {
                                            groups
                                                ? t('connect_bot.vk.groups.connect_group', 'Connect group')
                                                : t('connect_bot.vk.groups.create_group', 'Create new')
                                        }
                                    </div>

                                    {
                                        groups
                                            ? <span className='font-size-md'>
                                                    {t('connect_bot.vk.groups.title', 'Select group to connect with HighTouch')}
                                                </span>
                                            : <div className='font-size-md mt-4'>
                                                <Trans t={t} i18nKey='connect_bot.vk.groups.error_not_administrator'>
                                                     You have to be the group administrator to connect the group to
                                                    HighTouch.
                                                    {' '}<a href="https://vk.com/groups?w=groups_create" target='_blank' rel="noopener noreferrer">
                                                        Create a new group
                                                    </a>
                                                    or ask to make you an administrator of an existing one.
                                                </Trans>
                                            </div>
                                    }
                                </h4>
                            </div>
                        }
                        {
                            isSendingRequest && <Loader type="line-scale-party" active className='p-5 text-center'/>
                        }
                        {
                            !isSendingRequest && <ListGroup flush className='mt-2'>
                                {listGroupItems}
                            </ListGroup>
                        }
                        {
                            !isSendingRequest && groups === undefined && <div className="p-4 text-center">
                                <h6>🎃 {t('connect_bot.common.error_loading', 'Cannot load data')}</h6>
                                <Button color='primary' outline className='mt-2'
                                        onClick={() => window.location.reload()}>
                                    {t('connect_bot.common.try_again', 'Try again')}
                                </Button>
                            </div>
                        }
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <a href="#" className="btn-lg btn btn-link">
                            {t('connect_bot.vk.groups.re_login', 'Switch VK account')}
                        </a>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    isSendingRequest: state.Connect.isSendingRequest,
    groups: state.Connect.groups,
});

const mapDispatchToProps = dispatch => ({
    loadGroups: (base_url, callback) => dispatch(loadGroups(base_url, callback)),
    clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VKGroups);
